import React from "react";

interface CalloutProps {
  children: React.ReactNode;
  className?: string;
}

/**
 * A subtle callout container with a light background and border.
 * Used for highlighting content like criteria, notes, or context.
 */
export function Callout({ children, className = "" }: CalloutProps) {
  return (
    <div
      className={`rounded-md border border-border bg-muted px-2.5 py-2 text-sm text-foreground ${className}`}
    >
      {children}
    </div>
  );
}
